export default "__VITE_ASSET__vm1NYGAG__"